var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('DESP-GERAIS-FORN-02') && _vm.permiteSolicitar)?_c('b-button',{staticClass:"ml-2",attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarEnviar()}}},[_c('span',[_vm._v(" Solicitar Aprovação do "+_vm._s(_vm.cargo)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }